import { render } from "./ComponentTree.vue?vue&type=template&id=f1cd10ae&ts=true"
import script from "./ComponentTree.vue?vue&type=script&lang=ts"
export * from "./ComponentTree.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__